import { FC } from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { CalendarEditable } from 'TaxAnalyticsUI/icons';
import { DeloitteText } from 'TaxAnalyticsUI/Deloitte';

interface IEInvoicingCalendarProps {
    textColor?: string
}
const useStyles = makeStyles((theme) => ({
    list: {
        paddingInline: 22,
        fontWeight: 300,
        fontSize: '20px',
        color: theme.palette.text.primary,
        lineHeight: 2,
        marginBottom: 16
    }
}));
export const EInvoicingCalendar: FC<IEInvoicingCalendarProps> = (props) => {
    const classes = useStyles();
    return (

        <Grid container direction="row" alignItems="stretch" justifyContent="center" spacing={1}>
            <Grid container xs={12} md={6} alignItems="stretch" justifyContent="center">
                <Grid>
                    <CalendarEditable size={200} firstLine="1er Septembre" secondLine="2026" textColor={props.textColor} />
                </Grid>
                <Grid>
                    <Typography variant="h6">
                        Obligation d'émission pour les grandes entreprises et les ETI
                    </Typography>
                    <DeloitteText component="ul" className={classes.list}>
                        <li>
                            E-Invocing
                        </li>
                        <li>
                            E-Reporting
                        </li>
                    </DeloitteText>
                </Grid>
            </Grid>
            <Grid container xs={12} md={6} alignItems="stretch" justifyContent="center">
                <Grid>
                    <CalendarEditable size={200} firstLine="1er Septembre" secondLine="2027" textColor={props.textColor} />
                </Grid>
                <Grid>
                    <Typography variant="h6">
                        Obligation d'émission pour les PME et TPE
                    </Typography>
                    <DeloitteText component="ul" className={classes.list}>
                        <li>
                            E-Invocing
                        </li>
                        <li>
                            E-Reporting
                        </li>
                    </DeloitteText>
                </Grid>
            </Grid>
        </Grid>
    );
}